export default "/assets/images/chart-sm-02.svg?a15e34242f51df816956d3a8768b878b";